/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropUnifiedContentItem
 */
export interface DropUnifiedContentItem {
    /**
     * 
     * @type {string}
     * @memberof DropUnifiedContentItem
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof DropUnifiedContentItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropUnifiedContentItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropUnifiedContentItem
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropUnifiedContentItem
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropUnifiedContentItem
     */
    publishedAt: string;
    /**
     * 
     * @type {number}
     * @memberof DropUnifiedContentItem
     */
    durationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof DropUnifiedContentItem
     */
    viewCount?: number;
}

/**
 * Check if a given object implements the DropUnifiedContentItem interface.
 */
export function instanceOfDropUnifiedContentItem(value: object): value is DropUnifiedContentItem {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('publishedAt' in value) || value['publishedAt'] === undefined) return false;
    return true;
}

export function DropUnifiedContentItemFromJSON(json: any): DropUnifiedContentItem {
    return DropUnifiedContentItemFromJSONTyped(json, false);
}

export function DropUnifiedContentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropUnifiedContentItem {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'],
        'id': json['id'],
        'title': json['title'],
        'url': json['url'],
        'thumbnailUrl': json['thumbnailUrl'],
        'publishedAt': json['publishedAt'],
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
        'viewCount': json['viewCount'] == null ? undefined : json['viewCount'],
    };
}

export function DropUnifiedContentItemToJSON(json: any): DropUnifiedContentItem {
    return DropUnifiedContentItemToJSONTyped(json, false);
}

export function DropUnifiedContentItemToJSONTyped(value?: DropUnifiedContentItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'id': value['id'],
        'title': value['title'],
        'url': value['url'],
        'thumbnailUrl': value['thumbnailUrl'],
        'publishedAt': value['publishedAt'],
        'durationSeconds': value['durationSeconds'],
        'viewCount': value['viewCount'],
    };
}

